import { FC } from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Chip,
} from "@mui/material";
import { useCollectionsContext } from "../hooks/useCollectionsContext";
import { CollectionsActionsMenu } from "./CollectionsActionsMenu";
import { useCollectionDialogStore } from "../CollectionDialog/stores/CollectionDialogStore";

export const CollectionsDataState: FC = () => {
  const { collections, formatRelativeTime, filterBy } = useCollectionsContext();
  const { openEditMode } = useCollectionDialogStore();

  const isSharedTab = filterBy === "shared";

  return (
    <TableBody>
      {collections.map((collection) => {
        const canWrite = collection.permissions.can_write;

        return (
          <TableRow
            key={collection.id}
            data-testid={`collection-row-${collection.id}`}
            hover
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
          >
            <TableCell>
              <Typography
                variant="body2"
                color={canWrite ? "primary" : "text.primary"}
                sx={{ cursor: canWrite ? "pointer" : "default" }}
                onClick={canWrite ? () => openEditMode(collection) : undefined}
              >
                {collection.name}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="body2" color="text.secondary">
                {collection.type
                  .replace(/^rgif_|_collection$/g, "")
                  .split("_")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ")}
              </Typography>
            </TableCell>
            <TableCell>
              <Chip
                label={collection.blob.ids.length.toLocaleString()}
                size="small"
                variant="outlined"
                sx={{ cursor: "pointer" }}
              />
            </TableCell>
            <TableCell>
              <Typography variant="body2" color="text.secondary">
                {formatRelativeTime(collection.updated_at)}
              </Typography>
            </TableCell>
            {isSharedTab && (
              <TableCell>
                <Typography variant="body2" color="text.secondary">
                  {collection.owner_email ?? "—"}
                </Typography>
              </TableCell>
            )}
            <TableCell align="right">
              <CollectionsActionsMenu collection={collection} />
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  );
};
